import { FormControlLabel } from "@mui/material";
import { useTranslation } from "react-i18next";

import { useAppDispatch, useAppSelector } from "app/redux-store-interactions";
import { IosSwitch } from "components";
import {
    pointLineActions,
    selectLockPointLineElevation,
    selectLockPointLineVertical,
    selectShowPointAngleOnCanvas,
    selectShowPointHeightOnCanvas,
} from "features/pointLine";

import { SettingsPanel } from "./components/SettingsPanel";

export function PointToPointSettings() {
    const { t } = useTranslation();

    const showPointHeightOnCanvas = useAppSelector(selectShowPointHeightOnCanvas);
    const showPointAngleOnCanvas = useAppSelector(selectShowPointAngleOnCanvas);
    const lockPointLineElevation = useAppSelector(selectLockPointLineElevation);
    const lockPointLineVertical = useAppSelector(selectLockPointLineVertical);

    const dispatch = useAppDispatch();

    return (
        <SettingsPanel>
            <FormControlLabel
                sx={{ whiteSpace: "nowrap" }}
                control={
                    <IosSwitch
                        name="ptp-lock-horizontal"
                        checked={lockPointLineElevation}
                        color="primary"
                        onChange={() => {
                            dispatch(pointLineActions.toggleLockElevation());
                        }}
                    />
                }
                label={t("lockHorizontal")}
            />
            <FormControlLabel
                sx={{ whiteSpace: "nowrap" }}
                control={
                    <IosSwitch
                        name="ptp-lock-vertical"
                        checked={lockPointLineVertical}
                        color="primary"
                        onChange={() => {
                            dispatch(pointLineActions.toggleLockVertical());
                        }}
                    />
                }
                label={t("lockVertical")}
            />
            <FormControlLabel
                sx={{ whiteSpace: "nowrap" }}
                control={
                    <IosSwitch
                        name="ptp-show-point-z-on-canvas"
                        checked={showPointHeightOnCanvas}
                        color="primary"
                        onChange={(_e, checked) => {
                            dispatch(pointLineActions.setShowPointHeightOnCanvas(checked));
                        }}
                    />
                }
                label={t("showHeight")}
            />
            <FormControlLabel
                sx={{ whiteSpace: "nowrap" }}
                control={
                    <IosSwitch
                        name="ptp-show-point-angle-on-canvas"
                        checked={showPointAngleOnCanvas}
                        color="primary"
                        onChange={(_e, checked) => {
                            dispatch(pointLineActions.setShowPointAngleOnCanvas(checked));
                        }}
                    />
                }
                label={t("showAngles")}
            />
        </SettingsPanel>
    );
}
